<template>
  <div id="app">
    <div v-if="isLoading" class="loadingBox">
      <div id="loaded"></div>
    </div>
    <b-alert
      variant="danger"
      dismissible
      :show="error.is"
      @dismissed="error.is = !error.is"
      style="text-align:center"
    >
      <p>
        {{ error.message }}
      </p>
    </b-alert>
    <b-alert
      variant="success"
      dismissible
      :show="success.is"
      @dismissed="success.is = !success.is"
      style="text-align:center"
      v-html="success.message"
    >
    </b-alert>
    <b-form @submit="onSubmit">
      <div class="FormCliente mx-auto">
        <b-row>
          <b-col>
            <h4>{{ $t("message.personalData") }}</h4>
            <hr />
          </b-col>
        </b-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.name'))"
                for="name_contact"
                :invalid-feedback="errors.first('name_contact')"
                :state="!errors.has('name_contact')"
              />
              <b-form-input
                :data-vv-as="$t('message.name')"
                :state="errors.has('name_contact') ? false : null"
                v-validate="validate.text"
                v-model="form.name_contact"
                type="text"
                name="name_contact"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.surName'))"
                for="apellidos_contact"
                :invalid-feedback="errors.first('apellidos_contact')"
                :state="!errors.has('apellidos_contact')"/>
              <b-form-input
                :data-vv-as="$t('message.surName')"
                :state="errors.has('apellidos_contact') ? false : null"
                v-model="form.apellidos_contact"
                type="text"
                v-validate="validate.text"
                name="apellidos_contact"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.mobile'))"
                for="mobile"
                :invalid-feedback="errors.first('mobile')"
                :state="!errors.has('mobile')"
              />
              <b-form-input
                :data-vv-as="$t('message.mobile')"
                :state="errors.has('mobile') ? false : null"
                v-validate="validate.phone"
                v-model="form.mobile"
                type="text"
                name="mobile"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.email'))"
                for="email"
                :invalid-feedback="errors.first('email')"
                :state="!errors.has('email')"
              />
              <b-form-input
                :data-vv-as="$t('message.email')"
                :state="errors.has('email') ? false : null"
                v-model="form.email"
                v-validate="validate.correo"
                type="text"
                name="email"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <div class="FormEmpresa mx-auto">
        <b-row sm="11" md="11">
          <b-col>
            <h4>{{ $t("message.companyData") }}</h4>
            <hr />
          </b-col>
        </b-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.company'))"
                for="company"
                :invalid-feedback="errors.first('company')"
                :state="!errors.has('company')"
              />
              <b-form-input
                :data-vv-as="$t('message.company')"
                :state="errors.has('company') ? false : null"
                v-validate="validate.text"
                v-model="form.company"
                type="text"
                name="company"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.cif'))"
                for="cif"
                :invalid-feedback="errors.first('cif')"
                :state="!errors.has('cif')"
              />
              <b-form-input
                :data-vv-as="$t('message.cif')"
                :state="errors.has('cif') ? false : null"
                v-model="form.cif"
                type="text"
                v-validate="validate.cif"
                name="cif"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.profile'))"
                for="company_profile_id"
                :invalid-feedback="errors.first('company_profile_id')"
                :state="!errors.has('company_profile_id')"
              />
              <b-form-select
                :data-vv-as="$t('message.profile')"
                :state="errors.has('company_profile_id') ? false : null"
                :class="{ 'custom-select': true, 'is-invalid': errors.has('company_profile_id') }"
                v-validate="validate.notNull"
                v-model="form.company_profile_id"
                name="company_profile_id"
              >
                <b-form-select-option
                  v-for="(profile, key) in paramsAPI.companyProfiles"
                  :key="key"
                  :value="profile.id"
                >
                  {{ profile.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.phone'))"
                for="phone"
                :invalid-feedback="errors.first('phone')"
                :state="!errors.has('phone')"
              />
              <b-form-input
                :data-vv-as="$t('message.phone')"
                :state="errors.has('phone') ? false : null"
                v-model="form.phone"
                v-validate="validate.phone"
                type="text"
                name="phone"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.country'))"
                for="pais"
                :invalid-feedback="errors.first('pais')"
                :state="!errors.has('pais')"
              />
              <b-form-select
                :data-vv-as="$t('message.country')"
                :state="errors.has('pais') ? false : null"
                :class="{ 'custom-select': true, 'is-invalid': errors.has('pais') }"
                v-validate="validate.notNull"
                v-model="form.pais"
                name="pais"
              >
                <b-form-select-option v-for="(pais, key) in paramsAPI.country" :value="key" :key="key">
                  {{ pais.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.location'))"
                for="provincia"
                :invalid-feedback="errors.first('provincia')"
                :state="!errors.has('provincia')"
              />
              <b-form-select
                :data-vv-as="$t('message.location')"
                :state="errors.has('provincia') ? false : null"
                v-if="form.pais <= 0"
                :class="{ 'custom-select': true, 'is-invalid': errors.has('provincia') }"
                v-validate="validate.notNull"
                name="provincia"
              >
              </b-form-select>
              <b-form-select
                :data-vv-as="$t('message.location')"
                :state="errors.has('provincia') ? false : null"
                v-if="form.pais > 0"
                :class="{ 'custom-select': true, 'is-invalid': errors.has('provincia') }"
                v-model="form.provincia"
                v-validate="validate.notNull"
                name="provincia"
                @change="`console.log(${form})`"
              >
                <b-form-select-option
                  :value="prov.id"
                  v-for="(prov, key) in paramsAPI.country[form.pais].provincias"
                  :key="key"
                >
                  {{ prov.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.address'))"
                for="address"
                :invalid-feedback="errors.first('address')"
                :state="!errors.has('address')"
              />
              <b-form-input
                :data-vv-as="$t('message.address')"
                :state="errors.has('address') ? false : null"
                v-model="form.address"
                v-validate="'required'"
                type="text"
                name="address"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.city'))"
                for="city"
                :invalid-feedback="errors.first('city')"
                :state="!errors.has('city')"
              />
              <b-form-input
                :data-vv-as="$t('message.city')"
                :state="errors.has('city') ? false : null"
                v-model="form.city"
                v-validate="'required'"
                type="text"
                name="city"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.cp'))"
                for="cp"
                :invalid-feedback="errors.first('cp')"
                :state="!errors.has('cp')"
              />
              <b-form-input
                :data-vv-as="$t('message.cp')"
                :state="errors.has('cp') ? false : null"
                v-validate="validate.cp"
                v-model="form.cp"
                type="text"
                name="cp"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto" v-if="actionSend !== 'AirzoneSIM'">
            <b-form-group :label="$t('message.web')">
              <b-form-input v-model="form.website" type="text" name="website"> </b-form-input>
            </b-form-group>
          </b-col>
          <b-col class="mx-auto" v-if="actionSend === 'AirzoneSIM'">
            <b-form-group>
              <label
                v-html="isRequired($t('message.selectSim.label'))"
                for="conocer"
                :invalid-feedback="errors.first('conocer')"
                :state="!errors.has('conocer')"
              />
              <b-form-select
                :data-vv-as="$t('message.selectSim.label')"
                :state="errors.has('conocer') ? false : null"
                :class="{ 'custom-select': true, 'is-invalid': errors.has('conocer') }"
                v-model="form.conocer"
                v-validate="validate.notNull"
                name="conocer"
              >
                <b-form-select-option
                  v-for="(option, key) in $t('message.selectSim.options')"
                  :value="option"
                  :key="key"
                >
                  {{ option }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
        <b-form-row v-if="actionSend !== 'AirzoneSIM' && web_id != 2">
          <b-col class="mx-auto">
            <b-form-group>
              <label
                v-html="isRequired($t('message.comment'))"
                for="comments"
                :invalid-feedback="errors.first('comments')"
                :state="!errors.has('comments')"
              />
              <b-form-textarea
                name="comments"
                v-model="form.comments"
                :rows="3"
                :max-rows="6"
                :data-vv-as="$t('message.comment')"
                :state="errors.has('comments') ? false : null"
                v-validate="validate.comments"
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-form-row>
      </div>
      <b-form-row>
        <b-col class="mx-auto">
          <b-form-checkbox v-model="form.mailing" value="1" unchecked-value="0" name="terms">
            <label>
              {{ $t("message.infoComercial") }}
            </label>
          </b-form-checkbox>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col class="mx-auto">
          <b-form-checkbox
            v-model="form.terms"
            value="accepted"
            unchecked-value=""
            v-validate="validate.terms"
            name="terms"
          >
            <label v-if="getParameterUrl('wp')" v-html="isRequired($t('message.terms.wp'))">
            </label>
            <label v-if="!getParameterUrl('wp')" v-html="isRequired($t('message.terms.myzone'))">
            </label>
          </b-form-checkbox>
          <div
            :id="errors.has('terms') ? 'show' : 'noShow'"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            class="invalid-feedback d-block"
          >
            {{ $t("message.formsError.terms") }}
          </div>
        </b-col>
      </b-form-row>
      <b-row>
        <input type="hidden" name="recaptcha_response" id="recaptchaResponse" />
        <b-button class="mx-auto" type="submit" variant="primary">
          {{ $t("message.submit") }}
        </b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios';
import store from '@/store';

export default {
  name: 'form-vue',
  data() {
    return {
      isLoading: null,
      appMarket: 'es',
      actionSend: '',
      appLocale: 'es',
      web_id: 1,
      MyUrl: '',
      form: {
        email: '',
        name_contact: '',
        apellidos_contact: '',
        mobile: '',
        company: '',
        cif: '',
        company_profile_id: '',
        phone: '',
        pais: 0,
        provincia: 0,
        address: '',
        city: '',
        cp: '',
        website: '',
        mailing: 0,
        terms: '',
        comments: '',
        conocer: '',
      },
      error: {
        is: false,
        message: '',
      },
      success: {
        is: false,
        message: '',
      },
      validate: {
        text: 'required',
        correo: 'required|email',
        phone: 'required|min:9',
        cp: 'required|min:5',
        notNull: 'required|min_value:1',
        cif: 'min:9|required',
        terms: 'required|is:accepted',
        comments: 'required|max:1000',
      },
      paramsAPI: {
        companyProfiles: {},
        country: {},
      },
    };
  },
  // computed: {
  //   appConfig() { return store.getters.getSiteConfig; },
  // },
  methods: {
    getNameKey(variable, valueHijo, valuePadre = false, variable2 = false) {
      let result = '';
      const keys = Object.keys(this.paramsAPI[variable]);
      for (let i = 0; i <= keys.length; i += 1) {
        const key = keys[i];
        const cuerpo = this.paramsAPI[variable][key];
        if (variable2 !== false && valuePadre !== false) {
          if (cuerpo && String(cuerpo.id) === String(valuePadre)) {
            const newKeys = Object.keys(cuerpo[variable2]);
            for (let j = 0; j <= newKeys.length; j += 1) {
              const newKey = newKeys[j];
              if (
                cuerpo[variable2][newKey]
                && String(cuerpo[variable2][newKey].id) === String(valueHijo)
              ) {
                result = cuerpo[variable2][newKey].name;
              }
            }
          }
        } else if (cuerpo && cuerpo.id === valueHijo) {
          result = cuerpo.name;
        }
      }
      return result;
    },
    isRequired(name) {
      return `${name}<span style='color:#790000;margin-left:5px;font-size: 18px'>*</span>`;
    },
    getParameterUrl(name) {
      const newName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
      let results = new RegExp(`[\\?&]${newName}=([^&#]*)`);
      results = results.exec(window.location.search);
      return results === null ? false : decodeURIComponent(results[1].replace('/+/g', ' '));
    },
    async setValueParams() {
      return new Promise((resolve, reject) => {
        if (this.getParameterUrl('wp')) {
          this.appMarket = this.getParameterUrl('app-market');
          this.actionSend = this.getParameterUrl('action');
          this.appLocale = this.getParameterUrl('app-locale');
          this.web_id = this.getParameterUrl('web_id');
          this.MyUrl = window.location.origin;
          resolve(true);
        } else {
          store.dispatch('getSiteConfig').then(
            (response) => {
              this.MyUrl = response.Myurl;
              this.appMarket = response.appMarket;
              this.appLocale = response.lang;
              this.web_id = response.webId;
              resolve(response);
            },
            (error) => {
              console.log(error); // eslint-disable-line
              reject(error);
            },
          );
        }
      });
    },
    onSubmit(evt) {
      window.parent.postMessage('goTop', window.location.origin);
      evt.preventDefault();
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.isLoading = true;
          let add = false;
          if (this.actionSend === 'AirzoneSIM') {
            add = await this.addToMailList('a3047e8a53');
            if (add === true && this.getParameterUrl('wp')) {
              const redirect = this.getParameterUrl('redirect');
              if (redirect !== false) {
                setTimeout(() => {
                  window.top.location.href = redirect;
                }, 5000);
              }
            }
          } else {
            const nprofile = this.getNameKey('companyProfiles', this.form.company_profile_id);
            const dataForm = {};
            delete this.form.conocer;
            await this.$recaptchaLoaded();
            const token = await this.$recaptcha('new_application');
            Object.assign(dataForm, this.form, {
              web_id: this.web_id,
              company_profile_name: nprofile,
              token,
            });
            add = await this.addToMyzone(dataForm);
            if (add === true && this.getParameterUrl('wp')) {
              const redirect = this.getParameterUrl('redirect');
              if (redirect !== false) {
                setTimeout(() => {
                  window.top.location.href = redirect;
                }, 5000);
              }
            }
          }
        } else {
          this.isLoading = false;
          this.success.is = false;
          this.error.is = true;
          this.error.message = this.$t('message.formsError.front');
        }
      });
    },
    getProfileCustomer() {
      return new Promise((resolve, reject) => {
        const params = {
          headers: {
            'app-locale': this.appMarket,
            apikey: process.env.VUE_APP_APIKEY,
          },
        };
        const url = `${process.env.VUE_APP_URLAPI}/application/company-profiles`;
        axios
          .get(url, params)
          .then((response) => {
            // console.log('Success: ', response.data.body.company_profiles);  // eslint-disable-line
            resolve(response.data.body.company_profiles);
          })
          .catch((error) => {
            console.log("Error: ", error.response); // eslint-disable-line
            reject(error);
          });
      });
    },
    getCountry() {
      return new Promise((resolve, reject) => {
        axios
          .get(`${this.MyUrl}/soap.php?act=getCountry`)
          .then((response) => {
            // console.log('Success: ', response.data);  // eslint-disable-line
            resolve(response.data);
          })
          .catch((error) => {
            console.log("Error: ", error.response); // eslint-disable-line
            reject(error);
          });
      });
    },
    addToMailList(idList) {
      return new Promise((resolve, reject) => {
        const url = `${this.MyUrl}/soap.php?act=listMailchimp&job=add&idList=${idList}`;
        const params = {
          setting: {
            send: true,
            sendFrom: 'gabinete.tecnico@airzone.es',
            subject: 'Solicitud de Información AIRZONE SIM',
            template: 'AIRZONE_SIM',
            params: ['FNAME', 'LNAME'],
            nameFrom: 'Gabinete tecnico Airzone',
          },
          data: {
            email_address: this.form.email,
            status: 'subscribed',
            merge_fields: {
              FNAME: this.form.name_contact,
              LNAME: this.form.apellidos_contact,
              PHONE: this.form.mobile,
              COMPANY: this.form.company,
              CONFROM: this.form.conocer,
              CPROFILE: this.getNameKey('companyProfiles', this.form.company_profile_id),
              PROVINCE: this.getNameKey(
                'country',
                this.form.provincia,
                this.form.pais,
                'provincias',
              ),
              MAILING: String(this.mailing) === '1' ? 'SI' : 'NO',
              SEND: 'FALSE',
            },
          },
        };
        axios
          .post(url, params)
          .then((response) => {
            if (response.data.status === 200) {
              // console.log('Success: ', response.data); // eslint-disable-line
              this.error.is = false;
              this.success.is = true;
              this.success.message = this.$t('message.formsSuccess.AirzoneSIM');
              this.isLoading = false;
              resolve(true);
            } else {
              console.log("Error: ", response); // eslint-disable-line
              this.error.is = true;
              this.error.message = this.$t('message.formsError.server');
              this.success.is = false;
              this.isLoading = false;
              resolve(false);
            }
          })
          .catch((error) => {
            console.log("Error: ", error); // eslint-disable-line
            this.error.is = true;
            this.error.message = this.$t('message.formsError.server');
            this.success.is = false;
            this.isLoading = false;
            reject(error);
          });
      });
    },
    async addToMyzone(dataForm) {
      return new Promise((resolve, reject) => {
        const url = `${this.MyUrl}registerMyzone.php`;
        axios
          .post(url, dataForm)
          .then((response) => {
            if (response.data.status === 200) {
              // console.log('Success: ', response.data); // eslint-disable-line
              this.error.is = false;
              this.success.is = true;
              this.success.message = this.$t('message.formsSuccess.Myzone');
              this.isLoading = false;
              resolve(true);
            } else {
              console.log("Errors: ", response); // eslint-disable-line
              this.error.is = true;
              this.error.message = response.data.message;
              this.success.is = false;
              this.isLoading = false;
              resolve(false);
            }
          })
          .catch((error) => {
            console.log("Error: ", error); // eslint-disable-line
            this.error.is = true;
            this.error.message = this.$t('message.formsError.server');
            this.success.is = false;
            this.isLoading = false;
            reject(error);
          });
      });
    },
    addDataDefault() {
      this.form = {
        email: 'test@test.es',
        name_contact: 'Juan',
        apellidos_contact: 'Carmona',
        mobile: '123456789',
        company: 'NEW',
        cif: '12365478F',
        company_profile_id: '3',
        phone: '123456789',
        pais: 1,
        provincia: '20',
        address: 'Calle Falsa',
        city: 'NEW CITY',
        cp: '14510',
        website: 'wwww.test.es',
        mailing: 0,
        comments: 'ESTO ES UN TEST',
        terms: 'accepted',
      };
    },
  },
  async mounted() {
    await this.setValueParams();
    this.paramsAPI.country = await this.getCountry();
    this.paramsAPI.companyProfiles = await this.getProfileCustomer();
    // this.addDataDefault();
  },
};
</script>

<style>
#app {
  min-height: max-content;
  width: 100%;
  display: block;
  overflow: hidden;
  position: relative;
  height: auto;
  margin: 0 auto;
}
</style>
<style scoped>
h4 {
  text-align: center;
  text-transform: uppercase;
}
hr {
  max-width: 50%;
}
.FormEmpresa,
.FormCliente {
  margin-top: 1.5%;
}
.danger {
  border-color: red !important;
}
#show {
  display: block;
}
#noShow {
  display: none !important;
}
ul {
  list-style: none;
}

.loadingBox {
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  position: absolute;
  z-index: 100;
}

#loaded {
  margin: 0 auto;
  margin-top: calc(70% - 60px);
  border: 8px solid #f5f7fa;
  border-radius: 50%;
  border-top: 8px solid #01809e;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
  transition: visibility 0.5s linear;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
